import { IOnlinePartner } from '@core/interfaces/partner/online-partner.interface';

export const ONLINE_PARTNER_LIST: IOnlinePartner[] = [
  {
    activeEventCount: 3,
    imageId: '074ecf81-2940-4824-96cf-30d6b9e705b5',
    partnerName: 'Online koncertek a Zeneakadémián',
    partnerPageDomain: 'https://online-lisztacademy.jegy.hu',
  },
  {
    activeEventCount: 4,
    imageId: 'c6ee6ebf-13f5-435b-bfe2-3d039d691015',
    partnerName: 'Esernyős Kulturális Tér',
    partnerPageDomain: 'https://online-esernyos.jegy.hu',
  },
  {
    activeEventCount: 6,
    imageId: '23024a78-720e-4c6c-be9c-8c6b6e66f808',
    partnerName: 'Hagyományok Háza',
    partnerPageDomain: 'https://online-hagyomanyokhaza.jegy.hu',
  },
  {
    activeEventCount: 0,
    imageId: '821e3565-aefd-4dbc-9b72-95fbcca82df5',
    partnerName: 'Budavári Önkormányzat',
    partnerPageDomain: 'https://online-budavar.jegy.hu',
  },
  {
    activeEventCount: 5,
    imageId: '09526a90-9540-465a-bd0b-bcabc4230200',
    partnerName: 'Rendben Van Kft Pódiumbeszélgetések',
    partnerPageDomain: 'https://online-rendbenvan.jegy.hu',
  },
  {
    activeEventCount: 1,
    imageId: '6d977f16-dc84-42b2-bd97-88390be4693d',
    partnerName: 'Kolibri Színház',
    partnerPageDomain: 'https://online-kolibriszinhaz.jegy.hu',
  },
  {
    activeEventCount: 2,
    imageId: 'ddb5b8e2-fb13-4434-9084-371667fe032e',
    partnerName: 'Békéscsabai Jókai Színház',
    partnerPageDomain: 'https://online-jokaiszinhaz.jegy.hu',
  },
  {
    activeEventCount: 4,
    imageId: '3735b71f-589a-407f-a8da-29342fd243dd',
    partnerName: 'Budapesti Operettszínház',
    partnerPageDomain: 'https://online-operett.jegy.hu',
  },
  {
    activeEventCount: 3,
    imageId: '6eada449-3e1f-42cf-983d-2aae79604dd8',
    partnerName: 'Bartók Kamaraszínház',
    partnerPageDomain: 'https://oonline-bartokszinhaz.jegy.hu',
  },
];
